/**
 * From @zillow/constellation
 * | 0      320 | 321    480 | 481    768 | 769   1024 | 1025  1280 | 1281      ∞
 * | <--------> | <--------> | <--------> | <--------> | <--------> | <--------->
 * |     xs     |     sm     |     md     |     lg     |     xl     |     xxl
 */
const BREAKPOINTS = {
    xs: 321,
    sm: 481,
    md: 769,
    lg: 1025,
    xl: 1281
};

const _getScreenWidth = () => {
    if (typeof window !== 'undefined') {
        const width =
            window.innerWidth && document.documentElement.clientWidth
                ? Math.min(window.innerWidth, document.documentElement.clientWidth)
                : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (width <= BREAKPOINTS.xs) {
            return 'xs';
        } else if (width <= BREAKPOINTS.sm) {
            return 'sm';
        } else if (width <= BREAKPOINTS.md) {
            return 'md';
        } else if (width <= BREAKPOINTS.lg) {
            return 'lg';
        } else if (width <= BREAKPOINTS.xl) {
            return 'xl';
        } else {
            return 'xxl';
        }
    } else {
        return false;
    }
};

export const getDevice = () => {
    if (typeof window !== 'undefined') {
        const screenWidth = _getScreenWidth();
        return {
            screenWidth,
            isMobile: screenWidth === 'xs' || screenWidth === 'sm'
        };
    } else {
        return {};
    }
};
